export { funnelReviewsUpscale } from './funnelReviewsUpscale';
export { howItWorkUpscale } from './howItWorkUpscale';
export { benefitsUpscale } from './benefitsUpscale';
export { standsOutUpscale } from './standsOutUpscale';
